import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../storeHooks";
import useInfiniteScroll from "hooks/useInfinteScroll";
import { taskActions } from "../../redux/Ldb/actions/taskActions";
import { debounce, uniqBy } from "lodash";
import { workforceActions } from "redux/Ldb/actions";
import { AgentType } from "enums/AgentTypeEnum";

const useGetAllAgent = (params?: { agentType?: AgentType; refetch?: boolean }) => {
    const { agentType = "", refetch = false } = params || {};
    const dispatch = useAppDispatch();

    const [allAgentList, setAllAgentList] = useState<{ [key: string]: any }[]>([]);
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [type, setType] = useState<string>(agentType || "");

    const [pagination, setPagination] = useState<{ currentPage: string; noOfPages: string }>({
        currentPage: "1",
        noOfPages: "",
    });
    const { fetchingAllAgents, fetchAllAgentsSuccess, fetchAllAgentsFailure } = useAppSelector(
        (state) => state.workforce
    );

    const { updatedLimit, isLoadingMore, setLoadMore, updatedPage, setUpdatedPage } =
        useInfiniteScroll(
            {
                current: pagination.currentPage,
                number_of_pages: pagination.noOfPages,
            },
            20
        );

    useEffect(() => {
        setUpdatedPage(1);
    }, [debouncedSearch, type]);

    useEffect(() => {
        dispatch(workforceActions.getAllAgents(updatedLimit, updatedPage, debouncedSearch, type));
    }, [dispatch, debouncedSearch, updatedPage, type, refetch]);

    useEffect(() => {
        if (Boolean(fetchAllAgentsSuccess)) {
            setAllAgentList((prev) =>
                updatedPage === 1
                    ? uniqBy([...fetchAllAgentsSuccess?.agents], "_id")
                    : uniqBy([...prev, ...fetchAllAgentsSuccess?.agents], "_id")
            );

            setPagination({
                currentPage: fetchAllAgentsSuccess.pagination?.current,
                noOfPages: fetchAllAgentsSuccess.pagination?.number_of_pages,
            });
            setLoadMore(false);
        }
    }, [fetchAllAgentsSuccess]);

    return {
        isFetching: fetchingAllAgents,
        error: fetchAllAgentsFailure,
        data: allAgentList,
        setType,
        isLoadingMore,
        pagination,
        setUpdatedPage,
        setLoadMore,
        setDebouncedSearch,
        type,
    };
};

export default useGetAllAgent;
